import { render } from "./SearchCords.vue?vue&type=template&id=46f386a9"
import script from "./SearchCords.vue?vue&type=script&lang=js"
export * from "./SearchCords.vue?vue&type=script&lang=js"

import "./SearchCords.vue?vue&type=style&index=0&id=46f386a9&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__